<template>
  <div class="d-flex align-center gap-2">
    <special-genetics-icons
      v-if="validateGenetic"
      :genetics="discount.material_type"
    />
    <order-type-tooltip
      v-if="discount.TIPOP == 1"
      :value="orderDoctypes.PROMOTIONAL"
      label-type="productLabel"
    />
    <v-tooltip v-if="validateNR" bottom>
      <template #activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on">
          <v-img
            contain
            width="25px"
            height="25px"
            :src="require(`@/assets/img/icons_orders/NR.svg`)"
          />
        </span>
      </template>
      <span>No cuenta para Renglonaje</span>
    </v-tooltip>
    <order-type-tooltip
      v-if="discount.PNC == 1 && validateNR == false"
      :value="orderDoctypes.FIRST_TIME_PURCHASE"
      label-type="productLabel"
    />

    <div v-for="(item, index) in productDiscounts" :key="index">
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on">
            <v-img
              contain
              width="30px"
              height="30px"
              :src="require(`@/assets/img/discount_icons/${item.id}.svg`)"
            />
          </span>
        </template>
        <span>
          {{ item.description }}
          <span>{{ seePorcent(discount[item.id]) }}%</span>
        </span>
      </v-tooltip>
    </div>

    <v-tooltip v-if="productDiscountFactor" bottom>
      <template #activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on">
          <v-img
            contain
            width="40px"
            height="40px"
            :src="require(`@/assets/img/discount_icons/${discount.MVGR5}.svg`)"
          />
        </span>
      </template>
      <span
        >{{ productDiscountFactor.description }}
        {{ discount.MVGR5_POR }} %</span
      >
    </v-tooltip>

    <v-tooltip v-if="productDiscountZK14" bottom>
      <template #activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on">
          <v-img
            contain
            :width="counterPercent(discount.ZK14) > 2 ? '50px' : '30px'"
            :src="
              require(`@/assets/img/discount_icons/${productDiscountZK14.id}.svg`)
            "
          >
            <div class="d-flex fill-height">
              <span class="white--text text-caption font-weight-bold ma-auto">{{
                discountString(discount.ZK14)
              }}</span>
            </div>
          </v-img>
        </span>
      </template>
      <span
        >{{ productDiscountZK14.description }}
        {{ discountString(discount.ZK14) }}</span
      >
    </v-tooltip>
  </div>
</template>
<script>
  import OrderTypeTooltip from '@/components/tooltips/OrderTypeTooltip.vue';
  import SpecialGeneticsIcons from './SpecialGeneticsIcons.vue';
  import { OrderDoctypes } from '@/core/constants/orderDoctypeConstants';

  export default {
    name: 'SpecialDiscountIcon',
    components: {
      SpecialGeneticsIcons,
      OrderTypeTooltip,
    },
    props: {
      discount: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      orderDoctypes: OrderDoctypes,
      validateNR: null,
      validateGenetic: false,
      listOfDiscounts: [
        { id: 'ZKVL', description: 'Volumen' },
        { id: 'ZKRF', description: 'Familia' },
        { id: 'ZKRG', description: 'Renglonaje' },
        { id: 'ZKCM', description: 'Comercial' },
        { id: 'ZK69', description: 'Especial Familia' },
        { id: 'KPRK', description: 'Producto Combo' },
        { id: 'ZKDE', description: '' },
        { id: 'ZK25', description: 'Especial Renglón' },
        { id: 'ZK71', description: 'Descuento' },
        { id: 'ZKSP', description: 'Descuento Especial' },
        { id: 'MVGR5_POR', description: 'Factor' },
        { id: 'ZK14', description: 'Promoción' },
      ],
    }),

    computed: {
      productDiscounts() {
        return this.listOfDiscounts.filter((d) => {
          return (
            this.discount[d.id] != 0 && d.id != 'MVGR5_POR' && d.id != 'ZK14'
          );
        });
      },

      productDiscountFactor() {
        if (this.discount.MVGR5 != 0) {
          return this.listOfDiscounts.find((d) => d.id === 'MVGR5_POR');
        }

        return null;
      },

      productDiscountZK14() {
        if (this.discount.ZK14 != 0) {
          return this.listOfDiscounts.find((d) => d.id === 'ZK14');
        }

        return null;
      },
    },

    watch: {
      'discount.MVGR4': {
        immediate: true,
        handler(item) {
          const arrayData = ['1ZA', '1XA', '1ZB', '1ZC', '1YA'];
          this.validateNR = arrayData.includes(item);
        },
      },
      'discount.material_type': {
        immediate: true,
        handler(genetic) {
          if (this.$hasAnyRole(['Customer', 'CustomerPR'])) {
            if (genetic == 'D' || genetic == 'N') {
              this.validateGenetic = true;
            } else {
              this.validateGenetic = false;
            }
          }
        },
      },
    },
    methods: {
      discountString(value) {
        // This is because it does not display 0 when is INT
        const valuePercent = parseFloat(value * 100);
        const result = valuePercent - Math.floor(valuePercent) !== 0;
        if (result) {
          const decimal = valuePercent.toFixed(2);
          return `${decimal}%`;
        } else {
          const decimal = valuePercent.toFixed(0);
          return `${decimal}%`;
        }
      },
      counterPercent(value) {
        const valuePercent = parseFloat(value * 100);
        const result = valuePercent - Math.floor(valuePercent) !== 0;

        if (result) {
          const decimal = valuePercent.toFixed(2);
          return decimal.length;
        } else {
          const decimal = valuePercent.toFixed(0);
          return decimal.length;
        }
      },
      seePorcent(value) {
        return parseFloat(value * 100).toFixed(2);
      },
    },
  };
</script>
